import { getLeFEOrigin } from '@utils/util';

export const ActivityCfgLeFE = () => (
    <iframe className="admin-iframe" title="活动配置" src={`${getLeFEOrigin()}/#/app/admin/activity_cfg`} />
);
